import type { ButtonHTMLAttributes, ReactNode } from "react";

export type ButtonVariant = "primary" | "gold" | "success" | "secondary" | "danger" | "text";

interface ButtonProps extends ButtonHTMLAttributes<HTMLButtonElement> {
  variant?: ButtonVariant;
  children: ReactNode;
}

export function Button({ variant = "secondary", className = "", type = "button", children, ...props }: ButtonProps) {
  return (
    <button type={type} className={`mmm-btn mmm-btn--${variant} ${className}`.trim()} {...props}>
      {children}
    </button>
  );
}
